import { render } from "./UnidadesView.vue?vue&type=template&id=3e252b88&scoped=true"
import script from "./UnidadesView.vue?vue&type=script&lang=js"
export * from "./UnidadesView.vue?vue&type=script&lang=js"

import "./UnidadesView.vue?vue&type=style&index=0&id=3e252b88&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e252b88"]])

export default __exports__